
(function () {
  'use strict';
  angular.module('vcutils.vcshare')
    .component('sharesearch', {
      restrict: 'E',
      bindings: {
      share: '<',
  shareref: '<',
    parentsave: '&?',
    editinplace: '@?',
    ti: '@?'
},
  template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   autofocus
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showshare($item, $model, $label)"
                   uib-typeahead="share as share.text for share in vm.getShares($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="glyphicon glyphicon-refresh"></i>
        <div ng-show="noResults">
          <i class="glyphicon glyphicon-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addShare()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addShare()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <shareeditor share="vm.share"></shareeditor>
        </div>
        
        
      `,
    controllerAs: 'vm',
    controller: ['$log', 'Share', 'ShareHelper',
    function ($log, Share, ShareHelper) {
    let vm = this;
    vm.save = save;
    vm.showshare = showshare;
    
    vm.getShares = getShares;
    // vm.addShare = ShareHelper.addShare;
    vm.addShare = addShare;
    vm.editShare = ShareHelper.editShare;
    
    vm.$onInit = function () {
      vm.newshare = {};
      
      if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
        vm.editinplace = true;
      }
      
      $log.debug('debug - editinplace', vm.editinplace);
      
      
      if (angular.isUndefined(vm.ti))  {
        vm.ti = 0;
        vm.tabi = 0;
      }
      if (angular.isString(vm.ti)) {
        vm.tabi = parseInt(vm.ti, 10);
      }
      else {
        vm.tabi = 0;
      }
      vm.lastshare = angular.copy(vm.shareresult);
      vm.lastshareref = angular.copy(vm.shareref);
    };
    
    function addShare() {
      $log.debug('debug - sharesearch addShare called');
    ShareHelper.addShare(function (share) {
        $log.debug('debug: handle newly create share');
        vm.share = {};
        vm.share.name = share.name;
        vm.share.short = share.short;
        vm.share._id = share._id;
        vm.shareref = share._id;
        vm.asyncSelected = share.short;
        vm.parentsave({share: vm.share, shareref: vm.shareref});
      }, function (err) {
        vm.error = true;
        $log.error(err);
      });
    }
    
    
    // typeahead share search backend query
    function getShares(val) {
      // return Shareahead.$search({query: val}).$asPromise().then(function (response) {
      return Share.$searchahead({query: val}).$asPromise().then(function (response) {
        return response.map(function (share) {
        share.text = share.short;
          delete vm.error;
          return share;
        });
      });
    }
    
    // typeahead share search action
    function showshare($item, $model, $label) {
      /* jshint unused:false */
      /* eslint "no-unused-lets": [2, {"args": "none"}] */
      vm.share = $model;
      vm.shareref = $model._id;
      delete vm.asyncSelected;
      vm.editinplace = true;
      $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
      if (vm.editinplace === true) {
        vm.share = $model;
        vm.shareref = $model._id;
        $log.debug('debug - sharesearch editinplace');
      }
      else {
        vm.share = {};
        vm.share.name = $model.name;
        vm.share.short = $model.short;
        vm.share._id = $model._id;
        vm.shareref = $model._id;
        vm.parentsave({share: vm.share, shareref: vm.shareref});
        $log.debug('debug - sharesearch do not  editinplace', vm.parentsave);
      }
    }
    
    function save() {
      if (!angular.equals(vm.share, vm.lastshare) || !angular.equals(vm.shareref, vm.lastshareref) ) {
        vm.lastshare = angular.copy(vm.share);
        vm.lastshareref = angular.copy(vm.shareref);
        vm.parentsave({share: vm.share, shareref: vm.shareref});
      }
    }
    
    
  }] // controller
}); // component

// klammerfriedhof
}());